import { render, staticRenderFns } from "./CoproducerProductCard.vue?vue&type=template&id=2899bf01&scoped=true&"
import script from "./CoproducerProductCard.vue?vue&type=script&lang=js&"
export * from "./CoproducerProductCard.vue?vue&type=script&lang=js&"
import style0 from "./CoproducerProductCard.vue?vue&type=style&index=0&id=2899bf01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2899bf01",
  null
  
)

export default component.exports